var map = {
	"./A.svg": 1331,
	"./B.svg": 432,
	"./ExamLocations.svg": 3525,
	"./Graduation.svg": 8362,
	"./OfferHoldersDay.svg": 2909,
	"./PrayerAndReflectionLG.svg": 8302,
	"./UofG_App_Logo.svg": 9811,
	"./af_course.svg": 6601,
	"./af_failure.svg": 252,
	"./af_overdue.svg": 3266,
	"./af_submitted.svg": 6293,
	"./af_success.svg": 9099,
	"./apple-app-store-badge.svg": 4226,
	"./bell.svg": 5853,
	"./br_down.svg": 8725,
	"./br_up.svg": 3994,
	"./capacity.svg": 5706,
	"./chevron-down-light.svg": 8391,
	"./circle-tick.svg": 8468,
	"./cleanDeep.svg": 6411,
	"./cleanMaterials.svg": 5997,
	"./club_img.svg": 9654,
	"./defibrillator.svg": 4165,
	"./defibrillatorLG.svg": 7998,
	"./error_blue.svg": 6539,
	"./error_white.svg": 2286,
	"./event_bg.svg": 4060,
	"./event_img.svg": 1254,
	"./events-hmpg.svg": 5232,
	"./facemask.svg": 4845,
	"./far-chevron-down.svg": 952,
	"./far-chevron-left-disabled.svg": 8504,
	"./far-chevron-left-white.svg": 6871,
	"./far-chevron-left.svg": 8727,
	"./far-chevron-right-disabled.svg": 6315,
	"./far-chevron-right-white.svg": 5790,
	"./far-chevron-right.svg": 2418,
	"./find-a-building-hmpg.svg": 1969,
	"./gradeIcon.svg": 4672,
	"./greenTick.svg": 9300,
	"./group.svg": 3919,
	"./hw_counselling.svg": 665,
	"./hw_nightline.svg": 8320,
	"./hw_reporting.svg": 6910,
	"./hw_togetherall.svg": 7415,
	"./hw_wellbeing.svg": 3257,
	"./hw_wellbeing_lg_bkgnd.svg": 892,
	"./hw_wellbeing_sm_bkgnd.svg": 8607,
	"./maintenance.svg": 2127,
	"./map-hmpg.svg": 5003,
	"./no_internet.svg": 2585,
	"./noti-bell.svg": 3504,
	"./notif_bg.svg": 1038,
	"./period-productLG.svg": 3208,
	"./rag-amber.svg": 6446,
	"./rag-green.svg": 8430,
	"./rag-red.svg": 4254,
	"./redCross.svg": 2693,
	"./retail-outletLG.svg": 6352,
	"./solid-burger-fries-slash.svg": 2133,
	"./studentsupportofficers.svg": 4737,
	"./support-and-wellbeing-hmpg.svg": 1088,
	"./voteEnd.svg": 5985,
	"./voteStart.svg": 8866,
	"./voting-icon.svg": 607,
	"./wellbeing-support-hmpg.svg": 7928
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2282;